import { render, staticRenderFns } from "./Frutto.vue?vue&type=template&id=79c670d6&scoped=true&"
import script from "./Frutto.vue?vue&type=script&lang=js&"
export * from "./Frutto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c670d6",
  null
  
)

export default component.exports